module.exports = __webpack_public_path__ + "img/australia.fccb9372.svg";